<style scoped>
/* .item-container {
  max-width: 20rem;
  margin: 0;
}
.item {
  padding: 1rem;
  border: solid black 1px;
}
.item-sub {
  margin: 0 0 0 1rem;
} */
</style>

<template>
  <!-- <v-expansion-panels multiple flat hover> -->
  <draggable
    :value="localValue"
    :group="group"
    class="v-treeview v-treeview-draggable"
    ghost-class="ghost"
    @input="updateValue"
  >
    <menu-items-draggable-node
      v-for="item in value"
      :key="item.id"
      :group="group"
      :value="item"
      @input="updateItem"
      @update="onNodeUpdate"
      :ref="'itemRef' + item.id"
    >
      <template v-slot:prepend="{ item, open }">
        <slot name="prepend" v-bind="{ item, open }"></slot>
      </template>
      <template v-slot:label="{ item, open }">
        <slot name="label" v-bind="{ item, open }"></slot>
      </template>
      <template v-slot:append="{ item, open }">
        <slot name="append" v-bind="{ item, open }"></slot>
      </template>
    </menu-items-draggable-node>
    <!-- <div class="item-group" :key="el.id" v-for="el in realValue">
    <div class="item">{{ el.name }}</div>-->
    <!-- <v-expansion-panel
				v-for="el in realValue"
				:readonly="el.children.lenght == 0"
				:key="el.id"
			>
				<v-expansion-panel-header>{{ el.name }}</v-expansion-panel-header>
				<v-expansion-panel-content>
					<menu-item-draggable class="item-sub" :list="el.children" />
				</v-expansion-panel-content>
    </v-expansion-panel>-->
    <!-- <menu-item-draggable class="item-sub" :list="el.children" /> -->
    <!-- </div> -->
  </draggable>
  <!-- </v-expansion-panels> -->
</template>

<script>
import draggable from 'vuedraggable'
import MenuItemsDraggableNode from './MenuItemsDraggableNode'
import { EventBus } from '../../helpers/Events'

export default {
  name: 'menu-item-draggable',
  components: {
    draggable,
    MenuItemsDraggableNode
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
    // this.value when input = v-model
    // this.list  when input != v-model
    // realValue() {
    //   return this.value ? this.value : this.list;
    // }
  },
  props: {
    value: {
      type: Array,
      default: new Array()
    },
    group: {
      type: String,
      default: null
    },
    search: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localValue: [...this.value]
    }
  },
  watch: {
    value(value) {
      this.localValue = [...value]
    },
    search(value) {
      for (let item of this.localValue) {
        let refName = 'itemRef' + item.id
        let itemRef = this.$refs[refName][0]
        itemRef.onSearch(value)
      }
    }
  },
  methods: {
    updateValue(value) {
      this.localValue = value
      this.$emit('input', this.localValue)
    },
    updateItem(itemValue) {
      const index = this.localValue.findIndex(v => v.id === itemValue.id)
      this.$set(this.localValue, index, itemValue)
      this.$emit('input', this.localValue)
    },
    onNodeUpdate(value) {
      this.$emit('update', value)
      console.log('UPDATE RECEIVED!')
    }
  }
}
</script>
